import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotRecommend() {
  const hotComics = comics.filter((c) => c.rating >= 9.3).slice(0, 6);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">精选高分漫画，品质之选</p>
          </div>
          <Link
            to="/category/romance"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-product-shop>
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 韩国漫画 免费在线`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-2 left-2 flex flex-wrap gap-1">
                  {comic.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 text-[10px] font-medium bg-primary-500/90 text-background-50 rounded"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-amber-400 text-xs"></i>
                    <span className="text-xs text-background-50 font-medium">{comic.rating}</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{comic.updateTo}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}